import { ClienteService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const ClienteManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const listado = (where) => {
    return ClienteService.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const crear = (cliente) => {
    return ClienteService.crear(cliente).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const actualizar = (cliente) => {
    return ClienteService.actualizar(cliente).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const buscarPorId = (id) => {
    return ClienteService.buscarPorId(id).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };
  
  const listarRNCs = (where) => {
    return ClienteService.listarRNCs(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const buscarRNC = (rnc) => {
    return ClienteService.buscarRNC(rnc).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const exportar = (where) => {
    console.log(where);
    return ClienteService.exportar(where).then((res) => {
      return res;
    });
  };

  return { listado, crear, actualizar, buscarPorId, exportar, listarRNCs, buscarRNC };
})();